import { Component as BaseComponent, h } from 'preact';
import { connect } from 'react-redux';
import { Suspense, lazy } from 'preact/compat';
const InputGroup = lazy(
    () => import(/* webpackChunkName: "input-group" */ '../../../shared/form/input-group')
);

class Component extends BaseComponent {
    constructor(props) {
        super(props);
        this.state = { value: props.user.email };
    }

    render({ errors }, { value }) {
        return (
            <email-address>
                <row>
                    <column className='is-12'>
                        <Suspense fallback={<div className='skeleton' />}>
                            <InputGroup
                                type='email'
                                name='email'
                                value={value}
                                error={errors && errors.email}
                                placeholder='EMAIL ADDRESS'
                                onInput={this.handleChange}
                                noMultilineError='true'
                            />
                        </Suspense>
                    </column>
                </row>
            </email-address>
        );
    }

    /* eslint-disable no-useless-escape, max-len */
    handleChange = (e) => {
        const regex = /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
        let error = null;

        if (!e.target.value || e.target.value == '') {
            error = 'This field is required';
        } else if (!regex.test(e.target.value)) {
            error = 'Please enter a valid email address';
        }

        this.setState({ value: e.target.value });

        this.props.onChange(e.target.name, e.target.value, error);
    }
    /* eslint-enable no-useless-escape, max-len */
}


const mapStateToProps = (state) => ({
    user: state.user,
    errors: state.settings && state.settings.errors,
});

export default connect(mapStateToProps)(Component);
